sessionStorage.setItem('API_BASE','https://pvista.proevento.com.br/_soap/review/');
export const API_BASE = 'https://pvista.proevento.com.br/_soap/review/';